<template>
    <div>
        <div class="content">
            <h2 class="has-text-primary-dark">Buscador de documentos</h2>
        </div>

        <!-- Formulario de busqueda -->
        <div class="card">
            <div class="card-content">
                <form @submit.prevent="handleSubmit">
                    <div class="columns">
                        <div class="column">
                            <b-field
                                label="DNI / Nombre / Apellido"
                                label-position="on-border"
                            >
                                <b-input
                                    v-model="form.trabajador"
                                    name="empleado"
                                    icon-right="close-circle"
                                    icon-right-clickable
                                    @icon-right-click="form.trabajador = ''"
                                    autocomplete="off"
                                ></b-input>
                            </b-field>
                            <b-field
                                label="Tipo de Documento"
                                label-position="on-border"
                            >
                                <b-taginput
                                    v-model="form.tipos_documentos"
                                    :data="filteredTags.tipos"
                                    autocomplete
                                    open-on-focus
                                    attached
                                    field="descripcion"
                                    icon="label"
                                    type="is-primary is-light"
                                    @typing="getFilteredTagsTipos"
                                    @input="handleChangeTipoDocumento"
                                >
                                </b-taginput>
                            </b-field>
                            <b-field
                                v-if="showFilterGrupoDocumentos"
                                label="Grupo de Documento"
                                label-position="on-border"
                            >
                                <b-select
                                    placeholder="Selecciona una opción"
                                    v-model="form.grupo_documento_id"
                                    :loading="gruposDocumentosLoading"
                                    :disabled="gruposDocumentos.length === 0"
                                    expanded
                                    required
                                >
                                    <option
                                        v-for="option in gruposDocumentos"
                                        :value="option.id"
                                        :key="option.id"
                                    >
                                        {{ option.descripcion }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field
                                label="Periodo del documento"
                                label-position="on-border"
                            >
                                <b-datepicker
                                    type="month"
                                    icon="calendar-today"
                                    v-model="form.periodos"
                                    :mobile-native="false"
                                    range
                                >
                                </b-datepicker>
                            </b-field>
                            <b-field
                                label="Estado del Documento"
                                label-position="on-border"
                            >
                                <b-taginput
                                    v-model="form.estados_documentos"
                                    :data="filteredTags.estados"
                                    autocomplete
                                    open-on-focus
                                    attached
                                    field="descripcion"
                                    icon="label"
                                    type="is-primary is-light"
                                    @typing="getFilteredTagsEstados"
                                >
                                </b-taginput>
                            </b-field>
                        </div>
                    </div>
                    <div class="is-flex is-justify-content-center">
                        <b-button
                            type="is-primary"
                            native-type="submit"
                            :loading="isLoadingDocumentos"
                        >
                            Buscar
                        </b-button>
                    </div>
                </form>
            </div>
        </div>
        <br /><br />
        <!-- Resultados de la busqueda -->
        <tabla-busqueda :filters="filters" :pagination="pagination" />
    </div>
</template>

<script>
import moment from 'moment';

import TablaBusqueda from '../../../components/Documentos/TablaBusqueda.vue';
import Message from '@/utils/Message';

export default {
    components: {
        TablaBusqueda,
    },
    data() {
        return {
            showFilterGrupoDocumentos: false,
            isLoading: {
                buscar: false,
            },
            form: {
                trabajador: '',
                tipos_documentos: [],
                estados_documentos: [],
                periodos: [],
                grupo_documento_id: '',
            },
            filteredTags: {
                estados: [],
                tipos: [],
            },
            pagination: {
                per_page: 10,
                page: 1,
            },
        };
    },
    computed: {
        gruposDocumentos() {
            return this.$store.state.gruposDocumentos.data;
        },
        gruposDocumentosLoading() {
            return this.$store.state.gruposDocumentos.isLoading;
        },
        tiposDocumentos() {
            return this.$store.state.tiposDocumentos.data;
        },
        estadosDocumentos() {
            return this.$store.state.estados.data;
        },
        isLoadingDocumentos() {
            return this.$store.state.documentos.isLoading;
        },
        filters() {
            return {
                ...this.form,
                periodos: this.form.periodos.map((periodo) =>
                    moment(periodo).format('YYYY-MM-DD').toString()
                ),
                tipos_documentos: this.form.tipos_documentos.map(
                    (tipo) => tipo.descripcion
                ),
                estados_documentos: this.form.estados_documentos.map(
                    (estado) => estado.descripcion
                ),
            };
        },
    },
    async mounted() {
        await this.$store.dispatch('tiposDocumentos/get', {
            sort_param: 'descripcion',
            sort_order: 'ASC',
            per_page: 1000,
            page: 1,
        });
        await this.$store.dispatch('estados/get', 'documentos');

        this.getFilteredTagsTipos();
        this.getFilteredTagsEstados();

        await this.handleSubmit();
    },
    methods: {
        handleChangeTipoDocumento(value) {
            if (value.length !== 1) {
                this.showFilterGrupoDocumentos = false;
                this.form.grupo_documento_id = '';
                return;
            }

            const tipo_documento = value[0];

            if (tipo_documento.cantidad_grupos_documentos > 0) {
                this.showFilterGrupoDocumentos = true;
                this.fetchGruposDocumentos(tipo_documento.id);
            } else {
                this.showFilterGrupoDocumentos = false;
                this.form.grupo_documento_id = '';
            }
        },
        async fetchGruposDocumentos(tipo_documento_id) {
            await this.$store.dispatch('gruposDocumentos/get', {
                tipo_documento_id,
            });
        },
        getFilteredTagsTipos(text = '') {
            this.filteredTags.tipos = this.tiposDocumentos.filter((option) => {
                return (
                    option.descripcion
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0
                );
            });
        },
        getFilteredTagsEstados(text = '') {
            this.filteredTags.estados = this.estadosDocumentos.filter(
                (option) => {
                    return (
                        option.descripcion
                            .toString()
                            .toLowerCase()
                            .indexOf(text.toLowerCase()) >= 0
                    );
                }
            );
        },
        async handleSubmit() {
            try {
                this.$store.dispatch('documentos/setLoading', true);

                const res = await this.$store.dispatch('documentos/get', {
                    ...this.filters,
                    ...this.pagination,
                });
            } catch (err) {
                Message.showErrorMessage(this, err.message);
            } finally {
                this.$store.dispatch('documentos/setLoading', false);
            }
        },
    },
};
</script>

<style>
</style>
